
 export const dictations = [
 
// simple ---------------------------------------------
		{category: "degrees_level1", title: "1",
            degrees: "1 2 3 2 1 -7 1 ",
            tonicVtNote: "C/5", // kas vaja
            scale: "major",
        },
        {category: "degrees_level1", title: "2",
            tonicVtNote: "C/5",
            degrees: "1 2 1 -7   -6 -5 1 ",
            scale: "major",
        },
        {category: "degrees_level1", title: "3",
            tonicVtNote: "C/4",
            degrees: "1 2 3 4 5 6 5 ",
            scale: "major",
        },
        {category: "degrees_level1", title: "4",
            tonicVtNote: "C/5",
            degrees: "1 2 3 4 3 2 3 ",
            scale: "major",
        },
        {category: "degrees_level1", title: "5",
            tonicVtNote: "G/4",
            degrees: "1 -7   -6 -5 1 2 3 ",
            scale: "major",
        },

        {category: "degrees_level1", title: "6",
            tonicVtNote: "G/4",
            degrees: "1 -7 1 2  3 4 3 ",
            scale: "major",
        },
        {category: "degrees_level1", title: "7",
            tonicVtNote: "G/4",
            degrees: "1 2 3 4 5 1 -7 ",
            scale: "major",
        },
        {category: "degrees_level1", title: "8",
            tonicVtNote: "G/4",
            degrees: "1 2 3 1 3 4 5 ",
            scale: "major",
        },
        {category: "degrees_level1", title: "9",
            tonicVtNote: "F/4",
            degrees: "1 2 3 5 4 2 3  ",
            scale: "major",
        },
        {category: "degrees_level1", title: "10",
            tonicVtNote: "D/4",
            degrees: "1 3 5 4 3 5 1 ",
            scale: "major",
        },
		
		
		
		
		{category: "degrees_level1", title: "11",
            tonicVtNote: "F/5",
            degrees: "1 -7 1 -5 -6 -7 -5 ",
            scale: "major",
        },
		
		{category: "degrees_level1", title: "12",
            tonicVtNote: "F/4",
            degrees: "1 2 1 -5 1 2 3 ",
            scale: "major",
        },
		{category: "degrees_level1", title: "13",
            tonicVtNote: "A/4",
            degrees: "1 -7 1 2 3 1 -7 ",
            scale: "minorHarmonic",
        },
		
		{category: "degrees_level1", title: "14",
            tonicVtNote: "A/4",
            degrees: "1 -5 -6 -5 1 -7 1 ",
            scale: "minorHarmonic",
        },
		
		{category: "degrees_level1", title: "15",
            tonicVtNote: "A/4",
            degrees: "1 2 3 1 3 4 5 ",
            scale: "minorHarmonic",
        },
		
		{category: "degrees_level1", title: "16",
            tonicVtNote: "A/4",
            degrees: "1 -7 -6 -5 1 3 2 ",
            scale: "minorNatural",
        },
		
		{category: "degrees_level1", title: "17",
            tonicVtNote: "G/4",
            degrees: "1 -5 1 2 3 1 5 ",
            scale: "minorNatural",
        },
		
		{category: "degrees_level1", title: "18",
            tonicVtNote: "G/4",
            degrees: "1 2 3 5 6 5 4 ",
            scale: "major",
        },
		
		{category: "degrees_level1", title: "19",
            tonicVtNote: "G/4",
            degrees: "1 5 1 -7 1 3 2",
            scale: "minorHarmonic",
        },
		
		{category: "degrees_level1", title: "20",
            tonicVtNote: "E/4",
            degrees: "8 5 4 3 2 1 -7 ",
            scale: "minorHarmonic",
        },


     {category: "degrees_level1", title: "21",
         tonicVtNote: "F/4",
         degrees: "1 -7 1 -6 -5 1 2 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "22",
         tonicVtNote: "F/4",
         degrees: "1 3 5 6 4 5 1 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "23",
         tonicVtNote: "D/4",
         degrees: "1 5 3 2 5 6 5 ",
         scale: "minorNatural",
     },

     {category: "degrees_level1", title: "24",
         tonicVtNote: "D/5",
         degrees: "1 -5 1 3 2 -5 1 ",
         scale: "minorHarmonic",
     },

     {category: "degrees_level1", title: "25",
         tonicVtNote: "C/5",
         degrees: "3 4 5 1 5 8 5 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "26",
         tonicVtNote: "C/5",
         degrees: "2 1 -7 2 1 -5 5 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "27",
         tonicVtNote: "A/4",
         degrees: "3 2 1 -7 1 5 6 ",
         scale: "minorHarmonic",
     },

     {category: "degrees_level1", title: "28",
         tonicVtNote: "A/4",
         degrees: "1 2 3 -7 1 2 -5 ",
         scale: "minorHarmonic",
     },

     {category: "degrees_level1", title: "29",
         tonicVtNote: "G/4",
         degrees: "1 5 1 3 2 3 4 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "30",
         tonicVtNote: "G/4",
         degrees: "3 2 1 -7 -6 -5 2 ",
         scale: "major",
     },


     {category: "degrees_level1", title: "31",
         tonicVtNote: "E/5",
         degrees: " -5 1 -5 2 -5 3 1  ",
         scale: "minorNatural",
     },

     {category: "degrees_level1", title: "32",
         tonicVtNote: "E/5",
         degrees: "1 2 3 -5 -6 1 -7 ",
         scale: "minorHarmonic",
     },

     {category: "degrees_level1", title: "33",
         tonicVtNote: "F/5",
         degrees: "1 -5 -4 -3 -5 1 2 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "34",
         tonicVtNote: "F/4",
         degrees: "5 8 5 4 3 5 1 ",
         scale: "major",
     },

     {category: "degrees_level1", title: "35",
         tonicVtNote: "D/5",
         degrees: "1 2 1 -5 -6 -7 1 ",
         scale: "minorMelodic",
     },


     {category: "degrees_level1", title: "36",
         tonicVtNote: "D/5",
         degrees: "3 2 1 -7 -6 -5 1 ",
         scale: "minorNatural",
     },


     {category: "degrees_level1", title: "37",
         tonicVtNote: "C/5",
         degrees: "-5 1 -5 -4 -3 -4 -5 ",
         scale: "major",
     },


     {category: "degrees_level1", title: "38",
         tonicVtNote: "C/5",
         degrees: "-7 1 2 5 1 -5 1 ",
         scale: "major",
     },

     // original:
     // {category: "degrees_level1", title: "39",
     //     tonicVtNote: "A/4",
     //     degrees: "1 -7 -6 -7  1 6n 5 ", // TODO: support for melodic 6-natural
     //     scale: "minorMelodic",
     // },


     {category: "degrees_level1", title: "39",
         tonicVtNote: "A/4",
         degrees: "1 -7 -6 -7  1 6 5 ", // TODO: support for melodic 6-natural
         scale: "minorHarmonic",
     },

     {category: "degrees_level1", title: "40",
         tonicVtNote: "A/4",
         degrees: "3 1 2 -7 1 -6 -5 ",
         scale: "minorHarmonic",
     },


     {
         category: "degrees_level1", title: "41",
         tonicVtNote: "G/4",
         degrees: "8 5 8 4 8 3 1 ",
         scale: "major",
     },

     {
         category: "degrees_level1", title: "42",
         tonicVtNote: "G/4",
         degrees: "5 1 -7 5 1 6 5 ",
         scale: "major",
     },


     {
         category: "degrees_level1", title: "43",
         tonicVtNote: "E/4",
         degrees: "1 2 3 8 2 5 3",
         scale: "minorNatural",
     },


     {
         category: "degrees_level1", title: "44",
         tonicVtNote: "E/5",
         degrees: "3 1 -5 2 1 -7 1",
         scale: "minorHarmonic",
     },


     {
         category: "degrees_level1", title: "45",
         tonicVtNote: "F/4",
         degrees: "-7 1 3 7 8 4 2",
         scale: "major",
     },


     {
         category: "degrees_level1", title: "46",
         tonicVtNote: "F/4",
         degrees: "3 1 5 1 6 1 -7",
         scale: "major",
     },


     {
         category: "degrees_level1", title: "47",
         tonicVtNote: "D/5",
         degrees: "-5 -6 -7 1 2 -5 3",
         scale: "minorMelodic",
     },

     {
         category: "degrees_level1", title: "48",
         tonicVtNote: "D/5",
         degrees: "3 1 -7 2 -5 -7 1",
         scale: "minorHarmonic",
     },

     {
         category: "degrees_level1", title: "49",
         tonicVtNote: "C/4",
         degrees: "3 4 5 8 5 2 5",
         scale: "major",
     },

     {
         category: "degrees_level1", title: "50",
         tonicVtNote: "C/5",
         degrees: "5 1 5 -7 -6 2 1",
         scale: "major",
     },




 
];
